import { FC } from "react";

interface BillingProps {}

const Billing: FC<BillingProps> = () => (
  <>Billing</>
);

export default Billing;
